import {QbParticipantCollection} from "./base"
import {HEAD, PUT} from "@qb-assets-js/qb-fetch";
// import {QbSlot} from "./qb-slot";

export class QbTeam extends QbParticipantCollection {
    // get init() {
    //     super.init;
    // }

    set join_token(join_token) {
        console.log(this, {join_token});
    }
    set credits(credits) {
        console.log(this, {credits});
    }

    set slots_count(_) {}
}
QbTeam.register;